import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { renderIf } from 'core/utils';

function TableEmptyTemplate({ t, showImage, showLoader }) {
	return showLoader ? (
		<div className="w--400--px illustrate--center">
			<div className="pos--rel h--60">
				<div className="spinner spinner--g"></div>
			</div>
		</div>
	) : (
		<div className="w--400--px illustrate--center">
			{renderIf(showImage)(
				<img className="display--b spc--bottom--med spc--top--med" src={require('themes/img/es-default.svg')} />
			)}
			<p className="spc--bottom--med w--250--px align--h--center type--center">{t('LISTEMPTY.SEARCH')}</p>
		</div>
	);
}

export default defaultTemplate(TableEmptyTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/components/table/TableEmptyTemplate.jsx